import angular from 'angular';
import template from './template.html';
import { CandidatesList, CandidatesListConfiguration } from '../../../../candidate/candidates-list';
import './style.scss';

export class RecruiterCandidatesList extends CandidatesList {}

export const RecruiterCandidatesListConfiguration = {
    ...CandidatesListConfiguration,
    template,
    bindings: {
        ...CandidatesListConfiguration.bindings,
        candidatePageRoute: '@',
        currentRecruiter: '<',
        currentWorkflow: '<',
        feedbackFilterMode: '<',
    },
    controller: RecruiterCandidatesList,
    controllerAs: 'recruiterCandidatesListCtrl'
};

angular.module('TALENYA-FE').component('recruiterCandidatesList', RecruiterCandidatesListConfiguration);
